@if (selectedPerson) {
  <div
    class="pb-5">
    <div class="align-center space-between p-4 pl-5 pr-5">
      <div class="align-center">
        <sb-avatar [firstName]="selectedPerson.personData.firstName"
          [lastName]="selectedPerson.personData.lastName"
          [actionType]="AvatarButtonAction.None"
          class="mr-5"
          [personId]="selectedPerson.personData.id"
          size="xl"
          [isSoloPhoto]="true">
        </sb-avatar>
        <div>
          <h2 class="semi-bold"
            [innerHTML]="displayFullName()">
          </h2>
          <h3 class="p-large">
            <span [innerHTML]="subHeadingLabel() | translate"></span>
          </h3>
        </div>
      </div>
      <div class="align-center">
        @if (showUserStatus()) {
          <div
            [innerHTML]="selectedPerson.personStatus + '_User' | translate"
            class="semi-bold text-muted p-15">
          </div>
        }
        @if (showLocked()) {
          <div
            class="ml-3"
            style="display:flex; align-items: center;">
            <sb-icon name="info"
              class="mr-5"
            [ngbTooltip]="'SB_Unlock_Message' | translate"></sb-icon>
            <sb-button buttonClass="primary"
              (onClick)="isLocked = !isLocked"
            [message]="isLocked ? 'SB_Unlock' : 'SB_Lock'"></sb-button>
          </div>
        }
      </div>
    </div>
    <sb-wizard [(tabs)]="editUserTabs"
      [parentData]="selectedPerson"
      [hideImages]="true"
      [dangerButton]="deleteUserButton"
      [secondaryButton]="messageUserButton"
      [isSaving]="isSaving"
      (onSave)="saveUser($event)"
      (onDangerButtonClick)="deleteUserButtonClick()"
      (onSecondaryButtonClick)="sendSingleAccessRequestEmail()"
      [readOnly]="isReadOnly()">
      @if (selectedPerson.personData.id===currentUser.id) {
        <div class="orgs">
          <label>{{labels.organisations|translate}}</label>
          @for (org of currentUserOrganisations; track org) {
            <div> {{org}} </div>
          }
        </div>
      }
    </sb-wizard>
  </div>
}
